import { Flex } from '@lemonade-hq/cdk';
import { COLORS } from '@lemonade-hq/tokens';
import Image from 'next/image';
import type React from 'react';

export interface PressBannerProps {
  readonly img: string | StaticImageData;
}

export const PressBanner: React.FC<PressBannerProps> = ({ img }) => {
  return (
    <Flex pt={60} pb={12} background={COLORS.cloud} justifyContent="center" aria-hidden={true}>
      <Image
        src={img}
        alt="press banner"
        height={20}
        priority
        style={{
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      />
    </Flex>
  );
};
